module.exports = __webpack_public_path__ + "static/media/Chicago_Blackhawks.95d3ff8b.svg";